import Rule from "../../../../../common/rule";
import FootballState from "../../../../state/football-state";

export default class FieldGoalMissed extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.FieldGoalMissed;
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        gameContext.switchPossession();
        ruleContext.setAwardFirstDown(true);

        const { missedFieldGoalSpot, missedFieldGoalMinSpot } =
            eventConfiguration?.spots || {};
        if (missedFieldGoalSpot != null) {
            const { fieldLength } = gameContext.gameConfig.general;
            gameContext.setFieldPosition(
                gameContext.isHomePossession()
                    ? missedFieldGoalSpot
                    : fieldLength - missedFieldGoalSpot
            );
        } else if (missedFieldGoalMinSpot != null) {
            const { fieldLength } = gameContext.gameConfig.general;
            const { fieldPosition } = gameContext;
            if (gameContext.isHomePossession()) {
                if (fieldPosition < missedFieldGoalMinSpot) {
                    gameContext.setFieldPosition(missedFieldGoalMinSpot);
                }
            } else {
                if (fieldPosition > fieldLength - missedFieldGoalMinSpot) {
                    gameContext.setFieldPosition(
                        fieldLength - missedFieldGoalMinSpot
                    );
                }
            }
        }
    }
}
